import { createStyles, Card, Image, Text, Group } from "@mantine/core"
import React from "react"

// ----------------------------------------------------------------------

const useStyles = createStyles((theme) => ({
  card: {
    cursor: "pointer",
    transition: "transform 150ms ease, box-shadow 150ms ease",
    boxShadow: theme.shadows.md,
    display: "flex",
    overflow: "hidden",
    zIndex: 0,
    borderWidth: 1,
    borderStyle: "solid",

    "&:hover": {
      transform: "scale(0.97)",
      boxShadow: "none",
    },

    "&::before": {
      content: "\"\"",
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundImage: "url(assets/funky-lines.webp)",
      opacity: "0.2",
      zIndex: -2,
    },

    [theme.fn.smallerThan("xs")]: {
      flexDirection: "column",
    },
  },

  title: {
    fontWeight: 700,
    lineHeight: 1.2,

    [theme.fn.smallerThan("xs")]: {
      textAlign: "center",
    },
  },

  body: {
    flex: "auto",
    display: "flex",
    flexDirection: "column",
    marginLeft: theme.spacing.xl,

    [theme.fn.smallerThan("xs")]: {
      alignItems: "center",
      marginLeft: 0,
      marginTop: theme.spacing.xl,
    },
  },

  image: {
    alignSelf: "center",
  },
}))

// ----------------------------------------------------------------------

type Props = {
  image: string
  category: string
  title: string
  duration: string
  link: string
}

export function DirectionCard({ image, category, title, duration, link }: Props): React.JSX.Element {
  const { classes } = useStyles()

  return (
    <Card
      withBorder
      radius="md"
      className={classes.card}
      component="a"
      href={link}
      target="_blank"
    >
      <Image className={classes.image} src={image} height={96} width={96}/>
      <div className={classes.body}>
        <Text transform="uppercase" color="dimmed" weight={700} size="xs">
          {category}
        </Text>
        <Text className={classes.title} fz="lg" mt="xs" mb="md">
          {title}
        </Text>
        <Group noWrap spacing="xs" mt="auto">
          <Text size="xs" color="dimmed">
            Продолжительность
          </Text>
          <Text size="xs" color="dimmed">
            •
          </Text>
          <Text size="xs" color="dimmed">
            {duration}
          </Text>
        </Group>
      </div>
    </Card>
  )
}
